export type Rows = {
    [key: string]: any;
}[];

export type Columns = string[];

export enum ColumnGrouping {
    SOURCE_TYPE = "sourceType",
    ZONE_NAME = "zoneName",
    DATA_TYPE = "dataType",
}

export interface PerDataKeyValues {
    sourceIDsPerDataKey: Record<string, string>;
    sourceTypesPerDataKey: Record<string, string>;
    sourceNamesPerDataKey: Record<string, string>;
    dataTypesPerDataKeys: Record<string, string>;
    sourceZoneNamesPerDataKey: Record<string, string>;
    sourceVerdiIdsPerDataKey: Record<string, string>;
    sourceFieldNamesPerDataKey: Record<string, string>;
    latitudePerDataKey: Record<string, number | string>;
    longitudePerDataKey: Record<string, number | string>;
    depthPerDataKey: Record<string, number | string>;
}
